import React from 'react';

const LoadingGif = ({
  label = 'Loading...',
  onDark = false,
}) => {
  return (
    <div
      className='flex flex-col items-center justify-center gap-2'
      aria-label={label}
      role='status'
      aria-live='polite'
    >
      <img
        src='/loading.gif'
        alt=''
        aria-hidden='true'
        className={`h-auto w-auto max-w-full object-contain ${
          onDark ? 'invert drop-shadow-[0_0_6px_rgba(212,168,75,0.4)]' : ''
        }`}
      />
      <span className='sr-only'>{label}</span>
    </div>
  );
};

export default LoadingGif;
